import { Controller } from 'stimulus';
import debounce from '../helpers/debounce';
import myParcelRenderLocation from '../helpers/myParcelRenderLocation';
import myParcelValidateInput from '../helpers/myParcelValidateInput';
import dataLayer from '../helpers/dataLayer';

class MyParcel extends Controller {
  connect() {
    this.debouncedFetchPickupPoints = debounce(this.fetchPickupPoints.bind(this), 400);

    const orderDataElement = document.querySelector('[data-controller="order-data"]');
    this.orderDataController = this.application.getControllerForElementAndIdentifier(orderDataElement, 'order-data');

    this.getSelectorRadios()
      .forEach((input) => {
        input.addEventListener('change', this.onMethodChange.bind(this));
      });
  }

  getSelectorRadios() {
    const parentSelector = this.element.closest('.js-shipping-selectors');
    return Array.prototype.slice.call(parentSelector.querySelectorAll('input[type="radio"]'));
  }

  onMethodChange({ currentTarget }) {
    this.toggleMyParcel(MyParcel.isMyParcelToggle(currentTarget));
  }

  onKeyup() {
    this.debouncedFetchPickupPoints();
  }

  onChange() {
    this.fetchPickupPoints();
  }

  getApiUrl() {
    return this.data.get('api');
  }

  fetchPickupPoints() {
    if (!myParcelValidateInput(this.postalTarget.value, this.numberTarget.value)) {
      return Promise.resolve();
    }

    return this.makePickupsRequest()
      .then(this.outputResults.bind(this))
      .catch(this.showErrors.bind(this));
  }

  outputResults(res) {
    if (typeof res.pickup === 'undefined' || !res.pickup.length) {
      this.renderError('Er is geen ophaallocatie voor dit adres.');
      return;
    }

    dataLayer.event('MyParcel', 'results', `${res.pickup.length} locaties gevonden`);

    this.outputPickupLocations(res.pickup);
  }

  outputPickupLocations(locations) {
    const items = locations.slice(0, 10).map(myParcelRenderLocation);

    this.resultsTarget.innerHTML = `<div class="my-parcel__list">${items.join('')}</div>`;
    this.resultsTarget.removeAttribute('hidden');
  }

  showErrors() {
    dataLayer.event('MyParcel', 'error', `${this.postalTarget.value} ${this.numberTarget.value}`);

    this.renderError(`
      Er ging iets mis bij het ophalen van de ophaallocaties. Controleer je postcode
      en huisnummer, en probeer het opnieuw
    `);
  }

  showSpinner() {
    this.resultsTarget.innerHTML = 'Een moment geduld...';
    this.resultsTarget.removeAttribute('hidden');
  }

  renderError(errorText) {
    this.resultsTarget.textContent = errorText;
    this.resultsTarget.removeAttribute('hidden');
  }

  makePickupsRequest() {
    this.showSpinner();

    return new Promise((resolve, reject) => {
      if (typeof this.xhr !== 'undefined' && typeof this.xhr.abort === 'function') {
        this.xhr.abort();
      }

      this.xhr = $.ajax({
        url: this.getApiUrl(),
        type: 'POST',
        data: {
          postal: this.postalTarget.value,
          number: this.numberTarget.value,
        },
        success: resolve,
        error: reject,
      });
    });
  }

  selectLocation({ currentTarget }) {
    const oldActive = this.resultsTarget.querySelector('.is-active');

    if (oldActive) {
      oldActive.classList.remove('is-active');
    }

    currentTarget.classList.add('is-active');

    const information = JSON.parse(currentTarget.getAttribute('data-information'));
    information.locationName = `${information.location} ${information.street}`;

    this.orderDataController.myParcelOutputLocation(information);

    dataLayer.event('MyParcel', 'click', `${information.locationName} ${information.postal_code}`);
  }

  static isMyParcelToggle(element) {
    const dataTarget = element.getAttribute('data-target');

    if (!dataTarget) {
      return false;
    }

    return dataTarget.indexOf('my-parcel.toggle') >= 0;
  }

  toggleMyParcel(state) {
    const shippingAddressToggler = document.querySelector('.js-delivery-address-check-wrapper');

    shippingAddressToggler.style.display = !state ? 'block' : 'none';
    this.pickerTarget[state ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');
  }
}

MyParcel.targets = [
  'toggle',
  'picker',
  'postal',
  'number',
  'results',
];

export default MyParcel;
